import type { AvailabilityPage } from "@tenant/cars";
import { PackagesCarSlotProvider } from "../../slots";
import { PackageCarsAvailabilityPage } from "./PackageCarsAvailabilityPage";

export const PackageCarsAvailabilityPageWrapper = (
  props: React.ComponentProps<typeof AvailabilityPage>
) => {
  return (
    <PackagesCarSlotProvider>
      <PackageCarsAvailabilityPage {...props} />
    </PackagesCarSlotProvider>
  );
};
